import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminQuotesComponent from '../components/admin/quotes/AdminQuotes';
import '../styles/AdminQuotes.css';

export default function AdminQuotes() {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Gestion des Devis" 
          subtitle="Créez et envoyez des devis à vos clients"
        />
        <AdminQuotesComponent />
      </div>
    </div>
  );
}